import { render, staticRenderFns } from "./NoteMessageDialog.vue?vue&type=template&id=2876d2b4&scoped=true"
import script from "./NoteMessageDialog.vue?vue&type=script&lang=js"
export * from "./NoteMessageDialog.vue?vue&type=script&lang=js"
import style0 from "./NoteMessageDialog.vue?vue&type=style&index=0&id=2876d2b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2876d2b4",
  null
  
)

export default component.exports